import { Splide, URLHash } from "../main.js";
import { updateVariantsWidth } from "../utils.js";

// SLIDER
const productVariant = document.querySelector(".js-product-variant");
const productPhoto = document.querySelector(".js-product-photo");

// Slider functions
const updateVariantName = (variant) => {
  const variantElement = document.querySelector(
    ".single-product__hero-title [data-variant]",
  );

  if (variant !== null && variant !== undefined && variantElement) {
    variantElement.textContent = `${variant}`;
  } else {
    variantElement.textContent = "";
  }
};

// Replace ? to # //new syntax
const replaceHashVariant = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const variant = urlParams.get("variant");

  if (variant) {
    window.location.href = `${window.location.pathname}#variant=${variant}`;
  }
};

// A parameter row (colour, sun lens colour, light transmission) is filled and shown, or hidden when
// the colour has no value for it. A row the page doesn't have is skipped: before, an optical frame's
// missing sun lens row threw and stopped the rest of the update.
const setParameter = (specificationElement, attribute, value) => {
  const parameter = specificationElement.querySelector(
    `.single-product__parameters-parameter[${attribute}]`,
  );
  if (!parameter) {
    return;
  }
  const hasValue = value !== undefined && `${value}`.trim() !== "";
  parameter.textContent = hasValue ? `${value}` : "";
  parameter.closest("li").style.display = hasValue ? "block" : "none";
};

// The ERP writes the light transmission with its percent sign ("15,0%"), not always.
const withPercent = (value) =>
  value === undefined || `${value}`.trim() === "" || `${value}`.trim().endsWith("%")
    ? value
    : `${value}%`;

const updateVariantSpecification = (variants) => {
  const specificationElement = document.querySelector(".single-product__info");

  if (variants.collection !== undefined) {
    specificationElement.querySelector(
      ".single-product__parameters-parameter[data-collection]",
    ).textContent = `${variants.collection}`;
    specificationElement
      .querySelector(".single-product__parameters-parameter[data-collection]")
      .closest("li").style.display = "block";
  } else {
    specificationElement.querySelector(
      ".single-product__parameters-parameter[data-collection]",
    ).textContent =
      `${document.querySelectorAll(".js-product-photo li[data-collection]:not(.splide__slide--clone)")[0].dataset.collection}`;
  }

  setParameter(specificationElement, "data-color", variants.color);

  if (variants.description !== undefined) {
    specificationElement.querySelector(
      ".single-product__description[data-description] p",
    ).textContent = `${variants.description}`;
  } else {
    specificationElement.querySelector(
      ".single-product__description[data-description] p",
    ).textContent =
      `${document.querySelectorAll(".js-product-photo li[data-description]:not(.splide__slide--clone)")[0].dataset.description}`;
  }

  setParameter(specificationElement, "data-lens-color", variants.lensColor);
  setParameter(specificationElement, "data-lens-vlt", withPercent(variants.lensVlt));
};

if (productVariant && productPhoto) {
  // Call function for replace hash symbol
  replaceHashVariant();

  // GLOBAL
  let singleProductvariants;
  let singleProductphotos;

  // VARIANTS variables
  const productVariantLength =
    productVariant.querySelectorAll(".splide__slide").length;

  // CARDS variables
  const cardPhotoNextButton = document.querySelector(
    ".single-product__images .single-product__right-button",
  );
  const cardPhotoPrevButton = document.querySelector(
    ".single-product__images .single-product__left-button",
  );

  // VARIANTS SETTINGS
  singleProductvariants = new Splide(productVariant, {
    rewind: true,
    width: updateVariantsWidth(productVariantLength, 12, 5),
    perPage: productVariantLength <= 7 ? productVariantLength : 12,
    fixedWidth: 28,
    fixedHeight: 28,
    isNavigation: true,
    gap: 10,
    speed: 200,
    rewindSpeed: 100,
    focus: productVariantLength > 3 ? "center" : 0,
    easing: "cubic-bezier(.06,.78,.49,.98)",
    type: productVariantLength > 3 ? "loop" : "slide",
    pagination: false,
    arrows: false,
    drag: false,
    wheel: false,
    breakpoints: {
      1024: {
        width: updateVariantsWidth(productVariantLength, 9, 5),
        perPage: productVariantLength <= 5 ? productVariantLength : 9,
      },

      640: {
        width: updateVariantsWidth(productVariantLength, 7, 5),
        perPage: productVariantLength <= 4 ? productVariantLength : 7,
      },
    },
  });

  // PHOTO SETTINGS
  singleProductphotos = new Splide(productPhoto, {
    type: "loop",
    perPage: 2,
    perMove: 1,
    gap: 24,
    // heightRatio: 0.5,
    padding: "5rem",
    pagination: false,
    arrows: false,
    cover: true,
    focus: "center",
    speed: 700,
    lazyLoad: "sequential",

    breakpoints: {
      1920: {
        // perPage: 1,
        gap: 24,
        padding: "8rem",
      },

      1440: {
        // perPage: 1,
        gap: 24,
        padding: "3rem",
      },

      1024: {
        // perPage: 1,
        gap: 24,
        padding: "1rem",
      },

      768: {
        perPage: 1,
        gap: 10,
        padding: "4rem",
      },

      640: {
        perPage: 1,
        gap: 10,
        padding: "2rem",
      },
    },
  });

  // Events
  singleProductphotos.on("mounted", () => {
    updateVariantName(
      singleProductphotos.Components.Slides.getAt(singleProductphotos.index)
        .slide.dataset.variant,
    );
    updateVariantSpecification(
      singleProductphotos.Components.Slides.getAt(singleProductphotos.index)
        .slide.dataset,
    );
  });

  singleProductphotos.on("moved", () => {
    updateVariantName(
      singleProductphotos.Components.Slides.getAt(singleProductphotos.index)
        .slide.dataset.variant,
    );
    updateVariantSpecification(
      singleProductphotos.Components.Slides.getAt(singleProductphotos.index)
        .slide.dataset,
    );
  });

  // INIT
  singleProductvariants.mount({ URLHash });
  singleProductphotos.mount({ URLHash });
  singleProductphotos.sync(singleProductvariants);

  //attach events to custom buttons
  cardPhotoNextButton.addEventListener("click", (e) => {
    singleProductphotos.go("+1");
  });

  cardPhotoPrevButton.addEventListener("click", (e) => {
    singleProductphotos.go("-1");
  });
}

// The nearest stores and their popup: components/nearest-stores.js
